import type { UserProDto } from '@splitfiesta/shared';

import { userPro as normalizeUserPro } from '../../pro/pro';

/** Rows the import would create as expenses, against the caller's Free limit; null when it does not apply. */
export function importOverFreeLimit({
  expenseRows,
  userPro,
  now,
}: {
  expenseRows: number;
  userPro: UserProDto | undefined;
  now?: string;
}): { limit: number } | null {
  const pro = normalizeUserPro({ pro: userPro }, now);
  const limit = pro.freeGroupExpenseLimit ?? 0;
  if (limit === 0 || pro.active || expenseRows <= limit) return null;
  return { limit };
}
